import type { StaticLandingPage } from '../content';
import { resolveLandingPagePath } from '../routing';
import { qmLandingPage } from './academy-de/qm-landingpage/content';
import { academyEsPage } from './academy-es/in-company-training/content';
import { academyInPage } from './academy-in/accs/content';
import { academyInIcpPage } from './academy-in/icp/content';
import { academyInCisoPage } from './academy-in/ciso/content';
import { academyItPage } from './academy-it/sustainability-masterclass/content';
import { academyUsPage } from './academy-us/fusa-machinery/content';

export const staticPages: Record<string, StaticLandingPage> = {
  'aca-de-qm': qmLandingPage,
  'aca-es-incompany': academyEsPage,
  'aca-in-accs': academyInPage,
  'aca-in-icp': academyInIcpPage,
  'aca-in-ciso': academyInCisoPage,
  'aca-it-sustainability': academyItPage,
  'aca-us-fusa-machinery': academyUsPage,
};

export function getStaticLandingPages(): StaticLandingPage[] {
  return Object.values(staticPages);
}

export function getStaticLandingPage(pathname: string): StaticLandingPage | null {
  const resolvedPath = resolveLandingPagePath(pathname);
  return staticPages[resolvedPath] ?? null;
}
